<template>
  <div ref="ninosRef" class="ninos-section">
              <img src="@/assets/fotos.gif" alt="Gif de niños" class="ilustracion-ninos animate-item" />


      <p class="confirmacion-text">
        NO NIÑOS          <br>

        Amamos a los niños, pero hemos decidido que nuestra boda sea sin niños, esperando que no sea impedimento para acompañarnos en nuestro día.
          </p>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'AccesoNinosModal',
  setup() {
    const ninosRef = ref(null)
    const overlayVisible = ref(false)
    const elementosAnimados = ref([])

    const mostrarOverlay = () => {
      overlayVisible.value = true
      document.body.style.overflow = 'hidden'
    }

    const cerrarOverlay = () => {
      overlayVisible.value = false
      document.body.style.overflow = 'auto'
    }

    onMounted(() => {
      nextTick(() => {
        elementosAnimados.value = ninosRef.value.querySelectorAll('.animate-item')

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(elementosAnimados.value).indexOf(entry.target)
                gsap.fromTo(
                  entry.target,
                  { opacity: 0, y: 40 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    delay: index * 0.2,
                    ease: 'power2.out'
                  }
                )
                observer.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        elementosAnimados.value.forEach((el) => observer.observe(el))
      })
    })

    return {
      ninosRef,
      overlayVisible,
      mostrarOverlay,
      cerrarOverlay
    }
  }
}
</script>

<style scoped>
.ninos-section {
    background-image: url('@/assets/7.png'); /* 🔹 pon tu imagen aquí */
     background-size: cover;      /* 🔹 la imagen cubre todo */
  background-position: center; /* centrada */
  background-repeat: no-repeat; /* no se repite */  text-align: center;
  padding: 60px 0px;
  font-family: 'Playfair Display', serif;
  position: relative;
  margin-bottom: -40px;

}

.titulo {
  font-size: 26px;
  margin-bottom: 10px;
  color: #3d3d3d;
  letter-spacing: 2px;
}

.subtitulo {
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  color: #666;
  margin-bottom: 20px;
}

.btn-vermas {
  background: none;
  border: 1.5px solid #3d3d3d;
  color: #3d3d3d;
  font-family: 'Poppins', sans-serif;
  padding: 10px 24px;
  font-size: 13px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.btn-vermas:hover {
  background-color: #3d3d3d;
  color: #fff;
}

.flechas {
  margin-left: 10px;
  animation: moverFlechas 1s infinite alternate ease-in-out;
}

@keyframes moverFlechas {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(6px);
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.overlay-content {
  background: #fff;
  color: #333;
  border-radius: 12px;
  padding: 30px 20px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  position: relative;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 14px;
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #333;
}

.ilustracion-ninos {
  width: 450px;
  margin-bottom: 20px;
  margin-left:-20px;
}

.overlay-title {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  margin-bottom: 10px;
}

.overlay-text {
  font-size: 14px;
  line-height: 1.7;
  color: #555;
}

.btn-cerrar {
  margin-top: 20px;
  background: none;
  border: 1px solid #333;
  padding: 8px 18px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  cursor: pointer;
  transition: 0.3s ease;
}

.btn-cerrar:hover {
  background: #333;
  color: #fff;
}

.animate-item {
  opacity: 0;
  transform: translateY(40px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>